import React from 'react';
import PropTypes from 'prop-types';

import './section.scss';

const Section = (props) => {
  const { name, header, subHeader, dark } = props;
  const sectionStyles = ['landing-section'];
  if (dark) sectionStyles.push('section-dark');
  return (
    <section id={name} className={sectionStyles.join(' ')}>
      <div className="pb-5">
        <h2 className="section-header text-dark">{header}</h2>
        {subHeader && <p className="h4 font-weight-light">{subHeader}</p> }
      </div>
      {props.children}
    </section>
  );
};

export default Section;

Section.propTypes = {
  name: PropTypes.string.isRequired,
  header: PropTypes.string.isRequired,
  subHeader: PropTypes.string,
  dark: PropTypes.bool,
  children: PropTypes.node
};
